<template>
  <teleport to="body">
    <TransitionRoot
      enter="ease-in-out duration-150"
      enter-from="opacity-0"
      enter-to="opacity-100"
      leave="ease-in-out duration-150"
      leave-from="opacity-100"
      leave-to="opacity-0"
      as="template"
      appear
      :show="generalInternalStore.systemLoader"
    >
      <div
        class="fixed z-[999] top-header-top-with-discount inset-0 bg-black/25 backdrop-blur-[2.5px] transition-opacity flex justify-center items-center"
      >
        <img
          src="/images/loader.gif"
          alt="Loader"
          class="h-30 w-30 object-contain grayscale"
        />
      </div>
    </TransitionRoot>
  </teleport>
</template>

<script setup lang="ts">
import { TransitionRoot } from "@headlessui/vue";

const generalInternalStore = useGeneralInternalStore();
</script>
